var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadowChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#E0CFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 28C6 15.8497 15.8497 6 28 6C40.1503 6 50 15.8497 50 28C50 40.1503 40.1503 50 28 50C15.8497 50 6 40.1503 6 28Z",
    fill: "#6438B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6214 20.0858C39.4024 20.8669 39.4024 22.1332 38.6214 22.9142L26.2072 35.9142C25.4261 36.6953 24.1598 36.6953 23.3788 35.9142L17.3788 29.9142C16.5977 29.1332 16.5977 27.8669 17.3788 27.0858C18.1598 26.3048 19.4261 26.3048 20.2072 27.0858L24.793 31.6716L35.793 20.0858C36.574 19.3048 37.8403 19.3048 38.6214 20.0858Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowChecked);
export default __webpack_public_path__ + "static/media/shadowChecked.eeca044ea4a6c8383f747bba5ec8cc37.svg";
export { ForwardRef as ReactComponent };